import styled from 'styled-components';

const StyledJobsList = styled.div`
  margin: 0 auto;
  margin-top: ${props => props.theme.components_spacing_desk.xxlarge}px;
  margin-bottom: ${props => props.theme.components_spacing_desk.xxlarge}px;
  padding-right: 64px;
  padding-left: 64px;
  text-align: center;
  .list-title{
    text-transform: capitalize;
    text-align: left;
    margin-bottom: ${props => props.theme.components_spacing_desk.xlarge}px;
  }
  .jobs-column{
    position: relative;
    width: 100%;
  }
  .job-row{
    position: relative;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: ${props => props.theme.components_spacing_desk.large}px;
  }
  .job-row.header-row{
    margin-bottom: ${props => props.theme.components_spacing_desk.medium}px;
  }
  .job-cell{
    flex: 1 0 33.33%;
  }
  .job-cell:nth-child(1){
    text-align: left;
  }
  .job-cell:nth-child(2){
    text-align: center;
  }
  .job-cell:nth-child(3){
    text-align: right;
  }
  .load-btn{
    position: relative;
    margin: 0 auto;
    display: inline-flex;
    aling-items: center;
    min-width: 20%;
    color: ${ props => props.theme.colors.green_secondary};
    cursor: pointer;
  }
  .load-btn p{
    margin-right: 16px;
  }
  @media screen and (max-width: 1439px){
    padding-right: 40px;
    padding-left: 40px;
    
  }
  @media screen and (max-width: 1023px){
    .list-title{
      margin-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    }
    .job-row{
      margin-bottom: ${props => props.theme.components_spacing_tablet.large}px;
      flex-wrap: wrap;
    }
    .job-row.header-row{
      margin-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
    margin-top: ${ props => props.isIndex ? 0 : props.theme.components_spacing_tablet.xxlarge}px;
    margin-bottom: ${props => props.theme.components_spacing_tablet.xxlarge}px;

    .job-cell:nth-child(1){
      text-align: left;
      flex: 1 0 66%;
    }
    .job-cell:nth-child(2){
      text-align: right;
      flex: 1 0 33%;
    }
    .job-cell:nth-child(3){
      text-align: left;
      flex: 1 0 100%;
      margin-top: 24px;
    }
  }
  @media screen and (max-width: 767px){
    width: 100%;
    padding-right: 24px;
    padding-left: 24px;
    margin-top: ${ props => props.isIndex ? 0 : props.theme.components_spacing_mobile.xxlarge}px;
    margin-bottom: ${props => props.theme.components_spacing_mobile.xxlarge}px;
    .list-title{
      margin-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
    }
    .job-row{
      margin-bottom: ${props => props.theme.components_spacing_mobile.large}px;
    }
    .job-row.header-row{
      margin-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
  }

  @keyframes fadeIn {
    0%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
`;

export {
  StyledJobsList
};

